import { Card, CardContent } from "@/components/ui/card"
import { cn } from "@/lib/utils"
import { ChevronRight } from "lucide-react"

interface Props {
  onClick: () => void,
  title: string,
  isTitle?: boolean,
  disabled?: boolean,
}

const FolderCard: React.FC<Props> = ({
  onClick,
  title,
  isTitle = true,
  disabled = false,
}) => {
  return (
    <Card 
      className={cn(
        "cursor-pointer",
        disabled && "opacity-50 cursor-not-allowed"
      )} 
      onClick={disabled ? undefined : onClick}
    >
      <CardContent className="flex justify-between items-center">
        <p className={`font-semibold ${isTitle ? "text-lg" : "text-sm"}`}>{title}</p>
        <ChevronRight className="w-3 h-3" />
      </CardContent>
    </Card>
  )
}

export default FolderCard
